import React, { useState } from 'react';
import PdfIcon from "../../Assets/Images/PdfIcon.png";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';

export default function Resources({ fileName, fileSize, date, onDelete, onDownload }) {
  const [menu, setMenu] = useState(false);
  function toggleMenu() {
    setMenu(!menu);
  }

  return (
    <div className='card'>
      {menu && <div className="button-container">
        <Button sx={{borderBottom:"1px solid #CCCCCC"}} onClick={onDownload}>Download</Button>
        <Button onClick={onDelete}>Delete</Button>
      </div>}
      {menu ? <CloseIcon className='dot-icon' onClick={toggleMenu} />
      : <MoreVertIcon className='dot-icon' onClick={toggleMenu} />}
      <div className='main'>
        <img src={PdfIcon} alt='Pdf Icon' className='pdf-icon' />
        <p>{fileName}</p>
      </div>
      <div className='desc'>
        <p className='size'><span>SIZE</span>{fileSize}MB</p>
        <p className='date'>{date}</p>
      </div>
    </div>
  )
}
